import { createFileRoute } from "@tanstack/react-router";
import { MellanoWinnerDesignsView } from "src/tenantCustomizations/tenants/mellano/views/winner/MellanoWinnerDesignsView.tsx";

export const Route = createFileRoute("/_authenticated/_shell/mellano/winner/designs")({
	staticData: { title: "Winner", legacyViewKey: "mellanoWinnerDesignsView" },
	component: RouteComponent,
});

function RouteComponent() {
	return <MellanoWinnerDesignsView />;
}
